import { isMobile } from '@/utils/device'
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import MobilePage from '../views/MobilePage.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: HomePage,
      beforeEnter: (to, from, next) => {
        if (isMobile()) {
          next('/mobile')
        } else {
          next()
        }
      }
    },
    {
      path: '/mobile',
      component: MobilePage
    }
  ]
})
export default router